import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || (typeof window !== "undefined" ? window.location.origin : "");
const WS_URL = process.env.REACT_APP_WS_URL || (typeof window !== "undefined"
  ? ((window.location.protocol === "https:" ? "wss://" : "ws://") + window.location.host)
  : "");

// Operations
export const fetchOperations = async () => {
  const response = await axios.get(`${API_URL}/api/operations`);
  return response.data;
};

export const addOperation = async (operation) => {
  const response = await axios.post(`${API_URL}/api/operations`, operation);
  return response.data;
};

export const updateOperation = async (name, operation) => {
  const response = await axios.put(`${API_URL}/api/operations/${name}`, operation);
  return response.data;
};

export const deleteOperation = async (name) => {
  const response = await axios.delete(`${API_URL}/api/operations/${name}`);
  return response.data;
};

// Queue
export const fetchQueue = async () => {
  const response = await axios.get(`${API_URL}/api/queue`);
  return response.data.map((item) => ({
    ...item,
    originalFilename: item.originalFilename || item.filename,
    filename: item.filename,
  }));
};

export const pauseQueue = async () => {
  const response = await axios.post(`${API_URL}/api/queue/pause`);
  return response.data;
};

export const resumeQueue = async () => {
  const response = await axios.post(`${API_URL}/api/queue/resume`);
  return response.data;
};

// Upload and Process
export const uploadFile = async (file, operation) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("operation", operation);
  const response = await axios.post(`${API_URL}/api/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

// Progress
export const fetchProgress = async (filename) => {
  const response = await axios.get(`${API_URL}/api/progress/${filename}`);
  return response.data;
};

// Results
export const fetchResult = async (filename) => {
  const response = await axios.get(`${API_URL}/api/result/${filename}`);
  return response.data;
};

// History
export const fetchHistory = async () => {
  const response = await axios.get(`${API_URL}/api/history`);
  return response.data;
};

// Limpiar Historial
export const clearHistory = async () => {
  const response = await axios.post(`${API_URL}/api/history/clear`);
  return response.data;
};

// Eliminar Archivo Específico
export const deleteHistoryItem = async (filename) => {
  const response = await axios.delete(`${API_URL}/api/history/${filename}`);
  return response.data;
};

// Transcripción
export const fetchTranscriptionQueue = async () => {
  const response = await axios.get(`${API_URL}/api/transcribe/queue`);
  return response.data;
};

export const fetchTranscriptionHistory = async () => {
  const response = await axios.get(`${API_URL}/api/transcribe/history`);
  return response.data;
};

export const uploadAudio = async (audioFile) => {
  const formData = new FormData();
  formData.append("audio", audioFile);
  const response = await axios.post(`${API_URL}/api/transcribe/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const clearTranscriptionHistory = async () => {
  const response = await axios.post(`${API_URL}/api/transcribe/clear-history`);
  return response.data;
};

export const deleteTranscriptionItem = async (filename) => {
  const response = await axios.delete(`${API_URL}/api/transcribe/item/${filename}`);
  return response.data;
};

// Video
export const fetchVideoQueue = async () => {
  const response = await axios.get(`${API_URL}/api/video/queue`);
  return response.data;
};

export const fetchVideoHistory = async () => {
  const response = await axios.get(`${API_URL}/api/video/history`);
  return response.data;
};

export const processVideo = async (videoFile, audioFile, operation) => {
  const formData = new FormData();
  if (videoFile) formData.append("video", videoFile);
  if (audioFile) formData.append("audio", audioFile);
  formData.append("operation", operation);
  
  const response = await axios.post(`${API_URL}/api/video/process`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const clearVideoHistory = async () => {
  const response = await axios.post(`${API_URL}/api/video/clear-history`);
  return response.data;
};

export const deleteVideoItem = async (filename) => {
  const response = await axios.delete(`${API_URL}/api/video/item/${filename}`);
  return response.data;
};

// Text to Voice
export const fetchText2VoiceQueue = async () => {
  const response = await axios.get(`${API_URL}/api/text2voice/queue`);
  return response.data;
};

export const fetchText2VoiceHistory = async () => {
  const response = await axios.get(`${API_URL}/api/text2voice/history`);
  return response.data;
};

export const uploadTextForVoice = async (textFile, language, voice, engine, speaker, instruct) => {
  const formData = new FormData();
  formData.append("text", textFile);
  formData.append("language", language);
  if (voice) formData.append("voice", voice);
  if (engine) formData.append("engine", engine);
  if (speaker) formData.append("speaker", speaker);
  if (instruct) formData.append("instruct", instruct);
  
  const response = await axios.post(`${API_URL}/api/text2voice/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const fetchText2VoiceEngines = async () => {
  const response = await axios.get(`${API_URL}/api/text2voice/engines`);
  return response.data;
};

export const fetchText2VoiceVoices = async (engine = 'chatterbox') => {
  const response = await axios.get(`${API_URL}/api/text2voice/voices`, {
    params: { engine },
  });
  return response.data;
};

export const clearText2VoiceHistory = async () => {
  const response = await axios.post(`${API_URL}/api/text2voice/clear-history`);
  return response.data;
};

export const deleteText2VoiceItem = async (filename) => {
  const response = await axios.delete(`${API_URL}/api/text2voice/item/${filename}`);
  return response.data;
};

export const getText2VoiceProgress = async (filename) => {
  const response = await axios.get(`${API_URL}/api/text2voice/progress/${filename}`);
  return response.data;
};

export const retryText2VoiceItem = async (filename) => {
  const response = await axios.post(`${API_URL}/api/text2voice/retry/${filename}`);
  return response.data;
};

export const convertEpubToTxt = async (epubFile) => {
  const formData = new FormData();
  formData.append('epub', epubFile);
  const response = await axios.post(`${API_URL}/api/text2voice/epub-to-txt`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getConvertedTxtUrl = (filename) => {
  return `${API_URL}/api/text2voice/converted/${filename}`;
};

// Sequences
export const fetchFileTypes = async () => {
  const response = await axios.get(`${API_URL}/api/sequences/file-types`);
  return response.data;
};

export const fetchSequenceOperations = async () => {
  const response = await axios.get(`${API_URL}/api/sequences/operations`);
  return response.data;
};

export const fetchCompatibleOperations = async (inputType) => {
  const response = await axios.get(`${API_URL}/api/sequences/compatible-operations/${inputType}`);
  return response.data;
};

export const fetchSequences = async () => {
  const response = await axios.get(`${API_URL}/api/sequences`);
  return response.data;
};

export const fetchSequenceById = async (id) => {
  const response = await axios.get(`${API_URL}/api/sequences/${id}`);
  return response.data;
};

export const createSequence = async (sequence) => {
  const response = await axios.post(`${API_URL}/api/sequences`, sequence);
  return response.data;
};

export const updateSequence = async (id, sequence) => {
  const response = await axios.put(`${API_URL}/api/sequences/${id}`, sequence);
  return response.data;
};

export const deleteSequence = async (id) => {
  const response = await axios.delete(`${API_URL}/api/sequences/${id}`);
  return response.data;
};

export const executeSequence = async (id, inputFile) => {
  const formData = new FormData();
  formData.append('inputFile', inputFile);
  
  const response = await axios.post(`${API_URL}/api/sequences/execute/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const fetchSequenceExecutions = async () => {
  const response = await axios.get(`${API_URL}/api/sequences/executions/all`);
  return response.data;
};

export const fetchSequenceExecution = async (id) => {
  const response = await axios.get(`${API_URL}/api/sequences/executions/${id}`);
  return response.data;
};

// Helpers
export const getDownloadUrl = (filename) => {
  // Determinar el tipo de archivo basado en la extensión o patrones en el nombre
  if (filename.endsWith('.mp3') || filename.includes('_with_audio.mp4')) {
    return getVideoDownloadUrl(filename);
  }
  return `${API_URL}/api/result/download/${filename}`;
};

export const getVideoDownloadUrl = (filename) => {
  return `${API_URL}/api/video/download/${filename}`;
};

export const getTranscriptionDownloadUrl = (filename, format) => {
  if (format) {
    return `${API_URL}/api/transcribe/download/${filename}?format=${format}`;
  }
  return `${API_URL}/api/transcribe/download/${filename}`;
};

export const getText2VoiceDownloadUrl = (filename) => {
  console.log(`Generando URL de descarga para: ${filename}`);
  return `${API_URL}/api/text2voice/download/${filename}`;
};

export const getSequenceOutputDownloadUrl = (filename) => {
  if (!filename) return '#';
  
  // Asegurarse de usar sólo el nombre del archivo, no la ruta completa
  const justFilename = filename.split('/').pop();
  console.log(`Generando URL de descarga para secuencia: ${justFilename}`);
  return `${API_URL}/api/sequences/download/${justFilename}`;
};

export const getProgressUrl = (filename) => `${API_URL}/api/progress/${filename}`;
export const getWebSocketUrl = () => WS_URL; 